// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"2a03ae6b","384":"a440e4bc","453":"5e4cc8f7","788":"9ae42a09"}[chunkId] + ".chunk.js";
};